export const KYC_ERROR_MESSAGES: Record<string, string> = {
    partners_are_missing: "Inclua todos os sócios do quadro societário.",
    legal_name_mismatch: "O nome da razão social informado não confere com o registrado nos órgãos oficiais.",
    name_mismatch: "O nome do sócio informado não confere com o registrado nos órgãos oficiais."
};

export const translateKycError = (code: string) => KYC_ERROR_MESSAGES[code] || code;

export const KYC_ERROR_STATUSES = ["PENDING", "FAILED", "KYC_REJECTED"];

export const hasKycError = (status: string, reasons: string[]) =>
    KYC_ERROR_STATUSES.includes(status) && reasons.length > 0;
